<template>
    <div class="defaultButton">
        <van-button :disabled="!props.activeStatus" @click="props.onClick">{{ title }}</van-button>
    </div>
</template>

<script setup lang="ts">
import { ref, defineProps } from 'vue';
import type { PropType } from 'vue'

const props = defineProps({
    onClick: {
        type: Function as PropType<() => void>,
        required: false
    },
    title: {
        type: String,
        default: () => ''
    },
    activeStatus: {
        type: Boolean,
        default: false
    }
})

</script>
<style scoped>
.defaultButton>.van-button--default {
    background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%);
    color: #000000 !important;
    border-radius: 30px !important;
    font-weight: 700;
    border: none;
    padding: 20px 25px;
    font-size: 18px;
}

.van-button--normal {
    width: 100%;
}
</style>